// set env vars used by the app
export var datadogConfig = {
    applicationId: '06f787c5-114c-47ed-b589-b6e5fbe1c7a7',
    site: 'datadoghq.com',
    clientToken: 'pubc8838d3ffe6ce05a722407476b02a006',
    serviceId: 'lendigroup-leads-library',
};
//# sourceMappingURL=config.js.map